import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconTickComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-Tick${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><circle cx="24" cy="24" r="20" fill={useCurrentColor ? 'currentColor' : '#6FD13B'}/><path fillRule="evenodd" clipRule="evenodd" d="M35.422 17.177a2 2 0 01-.016 2.829L23.184 32.089a2 2 0 01-2.835-.023l-6.528-6.667a2 2 0 012.858-2.798l5.122 5.23 10.793-10.67a2 2 0 012.828.016z" fill={useCurrentColor ? 'currentColor' : '#fff'}/></svg>;
}

const IconTick = React.forwardRef(IconTickComponent);
export default IconTick;
